import { styled } from "@mui/material/styles";
import { Badge } from "@/shared/components";

export const LabelWrapper = styled("div")(() => ({
  position: "absolute",
  top: 0,
  right: 0,
  zIndex: 1,
}));

export const Label = styled(Badge)(({ theme }) => ({
  borderRadius: 0,
  borderLeft: `4px solid ${theme.palette.common.white}`,
  borderBottom: `4px solid ${theme.palette.common.white}`,
  fontSize: "1.125rem",
  fontWeight: 700,
  padding: theme.spacing(1, 2.5),

  [theme.breakpoints.down("md")]: {
    borderLeft: `2px solid ${theme.palette.common.white}`,
    borderBottom: `2px solid ${theme.palette.common.white}`,
    padding: theme.spacing(0.5, 1.5),
    fontSize: "0.875rem",
    fontWeight: 900,
  },
}));
